<template>
    <div class="prize-list-wrap">
        <v-row class="prize-list">
            <template v-for="item in items">
                <v-col cols="6" md="4" class="prize-list__item" :key="item">
                    <v-img :src="item.mobile" :alt="item.alt" class="d-lg-none" />
                    <v-img :src="item.image" :alt="item.alt" class="d-none d-lg-block" />
                </v-col>
            </template>
        </v-row>
    </div>
</template>

<script>
export default {
    data: () => ({
        items: [
            {
                mobile: "/images/event/clover/mobile/prize-1-mo.png",
                image: "/images/event/clover/prize-1.png",
                alt: "1등 백화점 상품권 10만원",
            },
            {
                mobile: "/images/event/clover/mobile/prize-2-mo.svg",
                image: "/images/event/clover/prize-2.svg",
                alt: "2등 나누리 상품권 5만원",
            },
            {
                mobile: "/images/event/clover/mobile/prize-3-mo.png",
                image: "/images/event/clover/prize-3.svg",
                alt: "3등 요기요 상품권 2만원",
            },
            {
                mobile: "/images/event/clover/mobile/prize-4-mo.png",
                image: "/images/event/clover/prize-4.svg",
                alt: "4등 설빙 상품권 1만원",
            },
            {
                mobile: "/images/event/clover/mobile/prize-5-mo.svg", 
                image: "/images/event/clover/prize-5.svg",
                alt: "5등 스타벅스 아메리카노",
            },
            {
                mobile: "/images/event/clover/mobile/prize-all-mo.svg",
                image: "/images/event/clover/prize-all.svg",
                alt: "모두 나누리캐시 500원",
            },
        ],
    }),
};
</script>

<style lang="scss" scoped>
.prize-list-wrap {
    max-width: calc(248 / 360 * 100%);
    margin: 0 auto;
    .prize-list {
        margin: -4px;
        &__item {
            padding: 4px;
        }
    }
}
@media (min-width: 768px) {
    .prize-list-wrap {
        max-width: calc(692 / 1920 * 100%);
        .prize-list {
            margin: -12px;
            &__item {
                padding: 12px;
            }
        }
    }
}
</style>